/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface PaginatedMaterialsEntityResponseDto
 */
export interface PaginatedMaterialsEntityResponseDto {
    /**
     * Array of Material entities
     * @type {Array<object>}
     * @memberof PaginatedMaterialsEntityResponseDto
     */
    items: Array<object>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof PaginatedMaterialsEntityResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the PaginatedMaterialsEntityResponseDto interface.
 */
export function instanceOfPaginatedMaterialsEntityResponseDto(value: object): value is PaginatedMaterialsEntityResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PaginatedMaterialsEntityResponseDtoFromJSON(json: any): PaginatedMaterialsEntityResponseDto {
    return PaginatedMaterialsEntityResponseDtoFromJSONTyped(json, false);
}

export function PaginatedMaterialsEntityResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMaterialsEntityResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'],
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function PaginatedMaterialsEntityResponseDtoToJSON(json: any): PaginatedMaterialsEntityResponseDto {
    return PaginatedMaterialsEntityResponseDtoToJSONTyped(json, false);
}

export function PaginatedMaterialsEntityResponseDtoToJSONTyped(value?: PaginatedMaterialsEntityResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'],
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

